import { Box, Button, Card, Tab, Tabs } from '@mui/material'
import React, { useEffect, useState } from 'react'
import PageHeaderLayout from '../../components/Layout/PageHeaderLayout'
import { useNavigate } from 'react-router-dom';
import { ArrowBack } from '@mui/icons-material';
import { useDispatch } from 'react-redux';
import Leads from './Leads/Leads';
import Events from './Events';
import Packages from './Packages';

const Lyns = () => {
    const menuDispatch = useDispatch();
        useEffect(() => {
            menuDispatch({
                type: 'menuSelect',
                payload: 'lyns'
            });
        }, []);
    const navigate = useNavigate();
    const [tabValue, setTabValue] = useState('0');
    const handleChange = (event, newValue) => {
        setTabValue(newValue);
    }
  return (
    <>
        <PageHeaderLayout headerTitle={'Manage Lyns'}>
            <Button size='small' variant='contained' onClick={() => navigate(-1)} endIcon={<ArrowBack sx={{fontSize:'.85rem'}}/>} sx={{ textTransform:'capitalize' }}>
                Back
            </Button>
        </PageHeaderLayout>
        <Card sx={{ minWidth: "100%", marginBottom: ".5%" }}>
            <Box sx={{ width: '100%' }}>
                <Tabs
                    value={tabValue}
                    onChange={handleChange}
                    textColor="secondary"
                    indicatorColor="secondary"
                    aria-label="secondary tabs example"
                    sx={{ p: 0, minHeight: '40px' }}
                    variant="scrollable"
                    scrollButtons="auto"
                >

                    <Tab value="0" label="Leads" sx={{ minHeight: '40px' , textTransform: 'capitalize' }} />
                    <Tab value="1" label="Events" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                    <Tab value="2" label="Packages" sx={{ minHeight: '40px', textTransform: 'capitalize' }} />
                </Tabs>
            </Box>
        </Card>
        {tabValue == '0' && <Leads />}
        {tabValue == '1' && <Events />}
        {tabValue == '2' && <Packages />}
      
    </>
  )
}

export default Lyns
